(function () {
  'use strict';

  var scheduled = false;
  var bodyObserver = null;
  var modalObserver = null;

  function watchModal(modal) {
    if (modalObserver) return;

    if (bodyObserver) {
      bodyObserver.disconnect();
      bodyObserver = null;
    }

    modalObserver = new MutationObserver(scheduleArrangement);
    modalObserver.observe(modal, {
      childList: true,
      subtree: true
    });
  }

  function arrangeShippingOptions() {
    scheduled = false;

    var modal = document.getElementById('dispatchgr-modal');
    if (!modal) return;
    watchModal(modal);

    var grid = modal.querySelector('.dg-courier-grid');
    if (!grid) return;

    var easyMail = grid.querySelector('[data-courier^="easymail"], .dg-courier-card--easymail');
    var boxNow = grid.querySelector('[data-courier^="boxnow"], .dg-courier-card--boxnow');

    if (easyMail && boxNow && grid.firstElementChild !== easyMail) {
      grid.insertBefore(easyMail, grid.firstElementChild);
    }

    if (easyMail) {
      var subtitle = easyMail.querySelector('.dg-courier-card__subtitle');
      var isEnglish = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
      var deliveryText = isEnglish ? 'Express delivery, next day (mainland Greece only)' : 'Άμεση παράδοση, την επόμενη ημέρα (για ηπειρωτική Ελλάδα)';

      if (subtitle) {
        if (subtitle.textContent.trim() !== deliveryText) {
          subtitle.textContent = deliveryText;
        }
        subtitle.style.fontWeight = '700';
      }
    }
  }

  function scheduleArrangement() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(arrangeShippingOptions);
  }

  function startShippingObserver() {
    scheduleArrangement();

    bodyObserver = new MutationObserver(scheduleArrangement);
    bodyObserver.observe(document.body, {
      childList: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startShippingObserver, { once: true });
  } else {
    startShippingObserver();
  }
})();
